export default "__VITE_ASSET__e6802ceb__"